<template>


    <div class="col-span-2 shadow-md h-full max-h-[90vh]">


        <div
            class="bg-white grid w-full col-span-2 px-6 overflow-x-hidden"
            style="grid-row-gap: 10px; grid-column-gap: 25px;"
            :style="`
                grid-template-columns: ${ grid_template_columns };
                grid-template-rows: 40px 2px;
                align-items: center;`">


            <div class="hover:bg-gray-50 w-full contents"
                 v-for="header in headers">


                <h3 class="pt-2">

                    {{ header.name }}

                </h3>


            </div>


            <div class="contents">

                <div style="margin: 0 -1.5rem;" class="border-b-2 border-b-gray-300 bg-white"
                :style="'grid-column: span ' + headers.length + ' / span ' + headers.length" />

            </div>


        </div>


        <div
            class="bg-white grid w-full col-span-2 px-6 pb-6 overflow-x-hidden overflow-y-scroll"
            style="padding-top: 10px; grid-row-gap: 10px; grid-column-gap: 25px; height: calc(100% - 50px)"
            :style="`
                grid-template-columns: ${ grid_template_columns };
                grid-template-rows: repeat(${ row_count }, minmax(min-content,max-content) 2px);
                align-items: center;`">


            <div v-for="(row, index) in rows"
                 :class="row_classes"
                 class="w-full contents">


                <div class=""
                    :class="header.class"
                    :style="header.style"
                    v-for="(header) in headers"
                    @click="$emit('click_on_row', row )">


                    <span
                        v-if=" ! header.type ">

                        {{ row[ header.text_key ] }}

                        {{ header.type }}

                    </span>


                    <slot v-else-if="header.type === 'slot'"
                        class=""
                        :name="header.value_key"
                        :row="row" />


                    <div v-else-if="header.type === 'status'"
                        class="bg-gray-300 py-3"
                        :class=" {
                            'bg-green': row[ header.value_key ] === 'active',
                            'bg-red-500': row[ header.value_key ] === 'paused',
                            'bg-blue': row[ header.value_key ] === 'new',
                            [header.class]: true
                        }">

                        {{ row[ header.text_key ] }}

                    </div>


                    <div v-else-if="header.type === 'html'"
                         v-html="row[ header.text_key ]" />


                    <img class="w-full"
                         v-else-if="header.type === 'image'"
                         style="height: 50px; object-fit: cover"
                         :src="default_image( row[ header.value_key ] )"
                         alt="Ad Image" />


                    <component v-else-if="header.type === 'component'"
                        :is="header.component"
                        :data="row[ header.value_key ]" />


                    <div v-else-if="header.type === 'topics'">


                        <div v-for="topic of row[header.text_key]" class="text-sm">

                            {{ topic }}

                        </div>


                    </div>

                    <div v-else-if="header.type === 'resend_button'">

                        <ResendConfirmModal :content_type_id="row[ header.value_key ]" :content_id="row.id"/>

                    </div>


                </div>


                <div class="contents">

                    <div style="margin: 0 -1.5rem;" class="border-b-2 border-b-gray-300 bg-white"
                        :style="'grid-column: span ' + headers.length + ' / span ' + headers.length" />

                </div>


            </div>


        </div>


    </div>


</template>


<script>
import { usePage } from '@inertiajs/inertia-vue3'
import ResendConfirmModal from "@/Components/ResendConfirmModal.vue";

export default {
    components: {ResendConfirmModal},

    props: {
        row_classes: {
            type: String,
            default: '',
        },
        headers: {
            type: Array,
            default: () => {
                return [
                    {
                        name: 'Status',
                        text_key: 'status_text',
                        value_key: 'status',
                        column_width: 0.8,
                        class: 'text-center text-white',
                        style: 'padding: 8px 0; margin-right: 20%; max-width: 1fr',
                    },
                    {
                        name: 'Campaign Name',
                        text_key: 'name',
                        value_key: 'name',
                        column_width: 4,
                        class: '',
                    },
                    {
                        name: 'Frequency',
                        text_key: 'frequency_text',
                        value_key: 'frequency',
                        column_width: 2,
                        class: '',
                    },
                    {
                        name: 'Last Sent',
                        text_key: 'last_sent',
                        value_key: 'last_sent',
                        column_width: 2,
                        class: '',
                    },
                    {
                        name: 'Subscribers',
                        text_key: 'subscribers',
                        value_key: 'subscribers',
                        column_width: 1,
                        class: '',
                    }
                ]
            }
        },
        rows: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Simple',
                        frequency: 'instant',
                        status: 'active',
                        last_sent: '24/01/22 - 12:32',
                        subscribers: 1002
                    },
                    {
                        id: 2,
                        name: 'Extended',
                        frequency: 'everyday',
                        status: 'active',
                        last_sent: '24/01/22 - 14:12',
                        subscribers: 10045
                    },
                    {
                        id: 3,
                        name: 'Compact',
                        frequency: 'once_a_week',
                        status: 'active',
                        last_sent: '25/01/22 - 08:23',
                        subscribers: 452
                    },
                    {
                        id: 4,
                        name: 'Welcome new subscribers',
                        frequency: 'once',
                        status: 'active',
                        last_sent: '25/01/22 - 09:35',
                        subscribers: 1533
                    },
                    {
                        id: 5,
                        name: 'Remind to update preferences',
                        frequency: 'once_after_14_days',
                        status: 'active',
                        last_sent: '25/01/22 - 09:55',
                        subscribers: 757
                    },
                    {
                        id: 6,
                        name: 'New Simple',
                        frequency: 'instant',
                        status: 'paused',
                        last_sent: '25/01/22 - 11:13',
                        subscribers: 12
                    },
                    {
                        id: 7,
                        name: 'New Extended',
                        frequency: 'everyday',
                        status: '0',
                        last_sent: 'N/A',
                        subscribers: 0
                    },
                ];
            }
        },
    },


    methods: {
        default_image(source) {

            if (source) {
                return source;
            }

            return '/images/ad-no-image-thumbnail.png'

        },
    },


    computed: {

        grid_template_columns() {

            return _.reduce(this.headers, (result, header) => {

                let width = header.column_width;

                if ( "number" === typeof width ) {
                    width = `${ width }fr`;
                } else {
                    width = width.toString();
                }

                if ( width.indexOf('minmax') > -1 ) {

                    width = header.column_width;

                }

                return result + ` ${ width }`;

            },'')

        },

        row_count() {

            return this.rows.length;

        }

    }

}
</script>

<style scoped>

</style>
